import Home from "../pages/Home.vue";
import FundReporting from "../pages/FundReporting.vue";
import FIReporting from "../pages/FIReporting.vue";
import FinancialInstitutions from "../pages/FinancialInstitutions.vue";
import ReferenceIndexes from "../pages/ReferenceIndexes.vue";
import MissingFundReports from '../pages/MissingFundReports.vue';
import DetectSuspiciousVariations from '../pages/DetectSuspiciousVariations.vue';
import CompareDataSources from '../pages/CompareDataSources.vue';
import Unauthorized from "../pages/Unauthorized.vue";

const routes = [
  {
    path: "/",
    component: Home,
    meta: { authorizedRoles: ["Research", "IT", "Admin"] },
  },
  {
    path: "/fund-reporting",
    component: FundReporting,
    meta: { authorizedRoles: ["Research", "IT", "Admin"]}
  },
  {
    path: "/fi-reporting",
    component: FIReporting,
    meta: { authorizedRoles: ["Research", "IT", "Admin"]}
  },
  {
    path: "/financial-institutions",
    component: FinancialInstitutions,
    meta: { authorizedRoles: ["Research", "IT", "Admin"]}
  },
  {
    path: "/reference-indexes",
    component: ReferenceIndexes,
    meta: { authorizedRoles: ["Research", "IT", "Admin"]}
  },
  {
    path: "/missing-fund-reports",
    component: MissingFundReports,
    meta: { authorizedRoles: ["Research", "IT", "Admin"]}
  },
  {
    path: "/detect-suspicious-variations",
    component: DetectSuspiciousVariations,
    meta: { authorizedRoles: ["Research", "IT", "Admin"]}
  },
  {
    path:'/compare-data-sources',
    component: CompareDataSources,
    meta: { authorizedRoles: ["Research", "IT", "Admin"]}
  },
  {
    path: "/unauthorized",
    component: Unauthorized,
  },
];

export default routes;
